import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withKeys as _withKeys, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test": "widget-skeleton"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = ["innerHTML"]

import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonHeader,
  IonContent,
  IonButton,
  IonModal,
  IonToolbar,
  IonSkeletonText,
  IonIcon,
} from "@ionic/vue";
import { SanityBlocks } from "sanity-blocks-vue-component";
import AlternativeActivity from "@/components/Common/AlternativeActivity/AlternativeActivity.vue";
import { useI18n } from "vue-i18n";
import { ref, onMounted } from "vue";
import { Block } from "sanity-blocks-vue-component/dist/types";

interface Props {
  alt_transcript?: Block[];
  altText?: string;
  cardContentClass: string;
  embedlink: string;
  isLoading: boolean;
  name: string;
  thumbnail: string;
  title: string;
  closeIcon: string;
  widgetRef: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityWidget',
  props: {
    alt_transcript: {},
    altText: {},
    cardContentClass: {},
    embedlink: {},
    isLoading: { type: Boolean },
    name: {},
    thumbnail: {},
    title: {},
    closeIcon: {},
    widgetRef: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n<{}>({
  useScope: "global",
});

const isOpen = ref(false);
const modal = ref();

onMounted(() => {
  if (history.state?.[`modalOpen_${props.widgetRef}`]) {
    isOpen.value = true;
  }
});

const openModal = () => {
  isOpen.value = true;
  history.pushState({ [`modalOpen_${props.widgetRef}`]: true }, "");
  window.onpopstate = () => {
    if (isOpen.value) {
      closeModal();
    } else {
      history.back();
    }
  };
};

const closeModal = () => {
  modal.value && modal.value.$el.dismiss(null, "cancel");
  isOpen.value = false;
};
const modalDismissed = () => {
  isOpen.value = false;
  window.onpopstate = null;
  if (history.state?.[`modalOpen_${props.widgetRef}`]) {
    history.back();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(IonSkeletonText), {
            style: {"width":"100%","height":"369px"},
            animated: true
          })
        ]))
      : (_openBlock(), _createBlock(_unref(IonCard), {
          key: 1,
          onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (openModal()), ["enter"])),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal())),
          tabindex: "0",
          "data-test": "activity-card"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCardHeader), { "data-test": "activity-card-header" }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  id: "resource-name",
                  class: "name",
                  "aria-label": `${_unref(t)('resource.interactive.button')} ${_ctx.title || ''}`
                }, _toDisplayString(props.title || ""), 9, _hoisted_2)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCardContent), {
              class: _normalizeClass(_ctx.cardContentClass)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: _ctx.thumbnail,
                    alt: props.altText,
                    "data-test": "thumbnail"
                  }, null, 8, _hoisted_3),
                  _createVNode(AlternativeActivity, {
                    "data-test": "alternative-activity",
                    show: !!_ctx.alt_transcript,
                    labelExpanded: _unref(t)('resource.activity.alternativeExpanded'),
                    labelCollapsed: _unref(t)('resource.activity.alternativeCollapsed')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SanityBlocks), { blocks: _ctx.alt_transcript }, null, 8, ["blocks"])
                    ]),
                    _: 1
                  }, 8, ["show", "labelExpanded", "labelCollapsed"])
                ])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })),
    _createVNode(_unref(IonModal), {
      "is-open": isOpen.value,
      ref_key: "modal",
      ref: modal,
      id: "widget-modal",
      "data-test": "modal-contents",
      onDidDismiss: modalDismissed,
      "aria-label": _ctx.name || '',
      "aria-labelledby": "resource-name"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(IonHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    "data-test": "close-button",
                    id: "closeModalBtn",
                    slot: "end",
                    fill: "outline",
                    color: "darkgrey",
                    size: "small",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (closeModal()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("navigation.close")) + " ", 1),
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _ctx.closeIcon
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonContent), null, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "iframe-wrapper",
                innerHTML: _ctx.embedlink
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["is-open", "aria-label"])
  ], 64))
}
}

})